import * as React from 'react';

import { getTranslation } from '@base/utils';

import { PaymentTitle } from './PaymentTitle';

export const PaymentError = () => {
	const paymentTranslation = getTranslation('pages.PaymentResult');

	return (
		<div>
			<PaymentTitle>{paymentTranslation('error')}</PaymentTitle>
		</div>
	);
};
